var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { gql } from '@apollo/client';
import { Box } from '../..';
import { jsx } from 'theme-ui';
/**
 *
 * @param {object} props
 * @param {string} props.alt The alt text. Mandatory. If the image is only decorative, use an empty string, otherwise describe what is in the image.
 * @param {{ src: string, srcSet?: string, width: number, height: number }} [props.fixed] A fixed-width image, one that always has the same size.
 * @param {{ src: string, srcSet?: string, sizes: string, aspectRatio: number, width: number, height: number }} [props.fluid] A fluid image that adapts to the available space of the parent. You can create hybrid variants by using the maxWidth.
 * @param {React.ReactElement?} [props.fallback] A fallback if no image is available.
 * @param {() => void} [props.onError] Handles loading errors.
 * @returns
 */
export default function Image(_a) {
    var { fixed, fluid, alt, fallback = null } = _a, rest = __rest(_a, ["fixed", "fluid", "alt", "fallback"]);
    if (fixed) {
        // @ts-ignore
        return jsx("img", Object.assign({}, fixed, { alt: alt }, rest));
    }
    if (fluid) {
        const { aspectRatio } = fluid, imgProps = __rest(fluid, ["aspectRatio"]);
        return (jsx(Box, { sx: { position: 'relative' } },
            jsx(Box, { sx: {
                    paddingBottom: `${100 / aspectRatio}%`,
                    maxWidth: imgProps.width,
                } }),
            jsx("img", Object.assign({}, imgProps, { alt: alt, 
                // @ts-ignore
                sx: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center center',
                } }, rest))));
    }
    return fallback;
}
Image.fixedImage = gql `
  fragment fixedImage on CloudinaryFixed {
    width
    height
    src
    srcSet
  }
`;
Image.fixedImage_noSrcSet = gql `
  fragment fixedImage_noSrcSet on CloudinaryFixed {
    width
    height
    src
  }
`;
Image.fluidImage = gql `
  fragment fluidImage on CloudinaryFluid {
    aspectRatio
    sizes
    src
    srcSet
    width
    height
  }
`;
//# sourceMappingURL=Image.js.map